import * as React from 'react';

import { cn } from '@shared/lib';

const Card = React.memo(
  React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
    ({ className, ...props }, ref) => (
      <div
        ref={ref}
        className={cn(
          'shadcn-card glass-card rounded-xl border bg-card border-card-border text-card-foreground shadow-sm',
          className
        )}
        {...props}
      />
    )
  )
);
Card.displayName = 'Card';

const CardHeader = React.memo(
  React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
    ({ className, ...props }, ref) => (
      <div ref={ref} className={cn('flex flex-col space-y-1.5 p-6', className)} {...props} />
    )
  )
);
CardHeader.displayName = 'CardHeader';

const CardTitle = React.memo(
  React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
    ({ className, ...props }, ref) => (
      <div
        ref={ref}
        className={cn('text-2xl font-semibold leading-none tracking-tight', className)}
        {...props}
      />
    )
  )
);
CardTitle.displayName = 'CardTitle';

const CardDescription = React.memo(
  React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
    ({ className, ...props }, ref) => (
      <div ref={ref} className={cn('text-sm text-muted-foreground', className)} {...props} />
    )
  )
);
CardDescription.displayName = 'CardDescription';

const CardContent = React.memo(
  React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
    ({ className, ...props }, ref) => (
      <div ref={ref} className={cn('p-6 pt-0', className)} {...props} />
    )
  )
);
CardContent.displayName = 'CardContent';

const CardFooter = React.memo(
  React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
    ({ className, ...props }, ref) => (
      <div ref={ref} className={cn('flex items-center p-6 pt-0', className)} {...props} />
    )
  )
);
CardFooter.displayName = 'CardFooter';
export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent };
